import { Box } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  width: string | object;
  minHeight?: string;
  paddingY?: number;
  paddingX?: number | object;
  backgroundColor?: string;
}

export const Layout: React.FC<Props> = ({
  children,
  width,
  minHeight = '100vh',
  paddingY = 8,
  paddingX = 0,
  backgroundColor = 'surfaceSecondaryFill'
}) => {
  return (
    <Box minHeight={minHeight} py={paddingY} backgroundColor={backgroundColor}>
      <Box maxWidth={width} marginX="auto" py={paddingY} px={paddingX}>
        {children}
      </Box>
    </Box>
  );
};
